import { LoadingSpinner as LoadingComponent } from '@almbrand/loadingspinner';
import styles from './LoadingSpinner.module.scss';

export const LoadingSpinner = () => {
	return (
		<div className={styles.LoadingSpinner}>
			<LoadingComponent
				color='primary'
				style='slow'
				type='circle'
			/>
		</div>
	);
};
